import ApiGateway from 'theme/api/api-gateway'
import { useFirebaseService } from 'theme/services/firebase-service'
import { useEffect, useState } from 'react'
import { useAuthService } from 'theme/services/auth/auth-service'
import { off } from 'firebase/database'

export const useAllUserSessions = () => {
  const [allRegistrations, setAllRegistrations] = useState(null)
  const firebase = useFirebaseService()
  const authService = useAuthService()
  const user = authService.user

  const getRegistrations = (conferenceId) => {
    if (!allRegistrations || (allRegistrations && !allRegistrations.length)) {
      return []
    }

    const conferenceItems = []

    allRegistrations.forEach((item) => {
      const registrations = Object.values(item)

      if (registrations && registrations.length) {
        registrations.forEach((registration) => {
          if (registration.productId === conferenceId) {
            conferenceItems.push(registration)
          }
        })
      }
    })

    return conferenceItems
  }

  useEffect(() => {
    if (!user) {
      return
    }

    const handleAllRegistrations = (allRegistrations) => {
      if (!allRegistrations) {
        return
      }

      setAllRegistrations(allRegistrations)
    }

    const registrationsDbRef = ApiGateway.observeAllUserRegistrations(
      firebase,
      user.uid,
      handleAllRegistrations,
    )

    return () => {
      if (registrationsDbRef) {
        off(registrationsDbRef)
      }
    }
  }, [user])

  return [getRegistrations]
}
